import { IAppState } from '../../common/state';

export function getIsNewbuildingBannerRotationEnabled({
  isNewbuildingBannerRandomRotationEnabled,
}: IAppState): boolean {
  return isNewbuildingBannerRandomRotationEnabled;
}
